import "./App.css";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme";
import { Routes, Route } from "react-router-dom";
import LoginPage from "./scenes/loginpage";
import Dashboard from "./scenes/dashboard";
import SideBar from "./scenes/global/SideBar";
import TopBar from "./scenes/global/TopBar";
import Products from "./scenes/products";
import Sales from "./scenes/sales";
import AddSaleForm from "./scenes/addsale";
import AddPurchase from "./scenes/addpurchase";
import Purchase from "./scenes/purchase";
import StockLedger from "./scenes/stockledger";
import ProtectedRoute from "./components/ProtectedRoute"; // 👈 add this
import Expenses from "./scenes/expenses";
import Services from "./scenes/services";
import CustomerDebts from "./scenes/customer_debts";
import Suppliers from "./scenes/suppliers";
import Customers from "./scenes/customer";
// Layout component
const Layout = ({ children }) => (
  <div className="app">
    <SideBar />
    <main className="content">
      <TopBar />
      {children}
    </main>
  </div>
);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        {/* Public route */}
        <Route path="/" element={<LoginPage />} />

        {/* Protected routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/products"
          element={
            <ProtectedRoute>
              <Layout>
                <Products />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/sales"
          element={
            <ProtectedRoute>
              <Layout>
                <Sales />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/addsale"
          element={
            <ProtectedRoute>
              <Layout>
                <AddSaleForm />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/addpurchase"
          element={
            <ProtectedRoute>
              <Layout>
                <AddPurchase />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/purchases"
          element={
            <ProtectedRoute>
              <Layout>
                <Purchase />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/stockledger"
          element={
            <ProtectedRoute>
              <Layout>
                <StockLedger />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/expenses"
          element={
            <ProtectedRoute>
              <Layout>
                <Expenses />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/services"
          element={
            <ProtectedRoute>
              <Layout>
                <Services />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/customerdebts"
          element={
            <ProtectedRoute>
              <Layout>
                <CustomerDebts />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/suppliers"
          element={
            <ProtectedRoute>
              <Layout>
                <Suppliers />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/customers"
          element={
            <ProtectedRoute>
              <Layout>
                <Customers />
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
